new Splide( '#heroPost',{
    perPage: 3,
    perMove: 1,
    trimSpace: false,
    pagination: false,
    arrows: false,
    gap: '8px',
    breakpoints: {
        1170: {
            perPage: 2,
            padding: { right: '3rem', left: '1rem'},
            gap: 0,
        },
        800: {
            perPage: 1,
            padding: { right: '3rem', left: '1rem' },
            gap: 0,
        },
    },

} ).mount();
//# sourceMappingURL=splide-control-post.js.map
